import axios from "axios";

export const listProgresses = (cursor, limit, success, failure) => {
    let url = "/api/v1/progress/list?limit=" + limit;

    if (cursor) {
        url += "&cursor=" + cursor;
    }

    axios.get(url)
        .then(response => {
            const json = response.data;

            success(json);
        })
        .catch(err => {
            failure(err);
        });
};

export const loadMine = (success, failure) => {
    axios.get("/api/v1/progress/mine")
    .then(response => {
        const json = response.data;

        success(json);
    })
    .catch(failure);
};

export const saveProgress = (courseId, documentId, videoId, music, success, failure) => {
    const url = `/api/v1/progress/`;

    axios.post(url, {
        courseId: courseId,
        documentId: documentId,
        videoId: videoId,
        music: music,
    })
        .then(response => {
            const json = response.data;

            success(json);
        })
        .catch(err => {
            failure(err);
        });
};
